import { type LinkInternal as LinkInternalType } from '@/sanity/schemaTypes/objects/link/linkInternalType';
import Link from 'next/link';
import { ReactNode } from 'react';

function LinkInternal({
  link,
  className,
  children
}: {
  link: LinkInternalType;
  className?: string;
  children?: ReactNode;
}) {
  if (!link?.reference?.slug) {
    return null;
  }
  const href = link.reference.slug?.startsWith('/')
    ? link.reference.slug
    : `/${link.reference.slug ?? ''}`;
  return (
    <Link href={href} className={className}>
      {children ?? link.reference.title}
    </Link>
  );
}

export default LinkInternal;
